const mechanicSubDirectory = "mechanic";

export const getMechanicsList = `${mechanicSubDirectory}/getAllMechanicsBasicInfo`;

export const getAllMechanicCollections = `${mechanicSubDirectory}/getAllMechanicCollectionsForSalesWebsite`;
